<!-- 房企选择 -->
<template>
    <el-cascader
        class="companySearch"
        :clearable="true"
        v-model="companyValue"
        :placeholder="placeholder"
        :options="options"
        :show-all-levels="false"
        :props="props"
        filterable
        @change="searchCompany">
    </el-cascader>
</template>

<script>
import ajaxService from '@/server/api.js'
export default {
    data() {
        return {
            companyValue:[],
            props: { multiple: true },
            options: [
                { value: '30', label: 'TOP30',},
                { value: '50', label: 'TOP50',},
                { value: '100', label: 'TOP100',},
                {
                    value: '4',
                    label: '全部房企',
                    children: []
                }
            ]
        }
    },
    props:{
        placeholder:{
            type:String,
            default(){
                return '搜索';
            }
        },
        company:{
            type:String,
            default(){
                return '';
            }
        },
    },
    created() {
        this.getCompanyList()
        this.initCompany()
    },
    methods: {
        initCompany(){
            // console.log(this.company)
            if(this.company==''){
                return
            }else if(this.company=='30'){
                this.companyValue=['30']
            }else if(this.company=='50'){
                this.companyValue=['50']
            }else if(this.company=='100'){
                this.companyValue=['100']
            }else{
                this.companyValue=['4',this.company]
            }
        },
        // 获取全部房企
        getCompanyList(){
            ajaxService.getCompany().then(res=>{
                console.log('获取全部房企',res)
                if(!res.ErrorCode){
                    res.Data.forEach(item=>{
                        if(item.ShortName){
                            let list = {
                                label:item.ShortName,
                                value:item.ShortName,
                            }
                            this.options[3].children.push(list)
                        }
                    })
                }
            })
        },
        searchCompany(){
            console.log(this.companyValue)
            this.$emit('searchCompany',this.companyValue[this.companyValue.length-1]);
        },
    }
}
</script>

<style lang="scss" scoped>
</style>
